import { useEffect, useState } from "react";
import { Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from "@mui/material";
import api from "../service/Api";
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import DoDisturbOutlinedIcon from '@mui/icons-material/DoDisturbOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';

export default function Usuarios() {
    const [users, setUsers] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getUsers = async () => {
            try {
                const response = await api.get('api/users');
                setUsers(response.data);
            } catch (err) {
                console.error('Erro na busca de usuários: ', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        getUsers();
    }, []);

    const handleApprove = async (id) => {
        try {
            await api.put(`api/user/${id}`, { approved: 1 });
            enqueueSnackbar('Usuário aprovado com sucesso!', { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            const updatedUsers = users.map((user) =>
                user.id === id ? { ...user, approved: 1 } : user
            );
            setUsers(updatedUsers);
        } catch (err) {
            console.error('Erro ao aprovar usuário: ', err);
        }
    };

    const handleBlock = async (id) => {
        try {
            await api.put(`api/user/${id}`, { approved: 0 });
            enqueueSnackbar('Usuário bloqueado com sucesso!', { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            const updatedUsers = users.map((user) =>
                user.id === id ? { ...user, approved: 0 } : user
            );
            setUsers(updatedUsers);
        } catch (err) {
            console.error('Erro ao bloquear usuário: ', err);
        }
    };

    const handleClickOpen = (id) => {
        setSelectedUserId(id);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedUserId(null);
    };

    const handleDelete = async () => {
        try {
            await api.delete(`api/user/${selectedUserId}`);
            enqueueSnackbar('Usuário deletado com sucesso!', { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            const updatedUsers = users.filter((user) => user.id !== selectedUserId);
            setUsers(updatedUsers);
            handleClose();
        } catch (err) {
            console.error('Erro ao excluir usuário: ', err);
            handleClose();
        }
    };

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <CircularProgress />
            </Grid>
        );
    }

    if (error) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <Typography color="error">Error: {error}</Typography>
            </Grid>
        );
    }

    return (
        <Grid container justifyContent="center">
            <Grid item xs={12}>
                <Paper sx={{ padding: 2, margin: 'auto', marginTop: 4, marginBottom: 4, maxWidth: 1100 }}>
                    <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center' }}>
                        Lista de Usuários
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Aprovação</TableCell>
                                    <TableCell>Data de Criação</TableCell>
                                    <TableCell>Última Atualização</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.map((user) => (
                                    <TableRow key={user.id}>
                                        <TableCell>{user.name}</TableCell>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>{user.approved ? <DoneIcon sx={{ color: 'green' }} /> : <CloseIcon sx={{ color: 'red' }} />}</TableCell>
                                        <TableCell>{new Date(user.created_at).toLocaleDateString()}</TableCell>
                                        <TableCell>{new Date(user.updated_at).toLocaleDateString()}</TableCell>
                                        <TableCell sx={{
                                            display: 'flex',
                                            gap: 1,
                                            alignItems: 'center'
                                        }}>
                                            <Button onClick={() => handleApprove(user.id)} variant="contained" size="small" color="success"> <ThumbUpAltOutlinedIcon /> </Button>
                                            <Button onClick={() => handleBlock(user.id)} variant="contained" size="small" color="primary"> <DoDisturbOutlinedIcon /> </Button>
                                            <Button onClick={() => handleClickOpen(user.id)} variant="contained" size="small" color="error"> <DeleteOutlineOutlinedIcon /> </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirmação de Exclusão"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Confirmar exclusão do usuário?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button onClick={handleClose} variant="contained" sx={{ width: '35%' }} color="error">
                        <CloseIcon sx={{ color: '#fff' }} />
                    </Button>
                    <Button onClick={handleDelete} variant="contained" sx={{ width: '35%' }} color="success" autoFocus>
                        <DoneIcon sx={{ color: '#fff' }} />
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
